<script>

import { Overlay } from '../../'

export default {
    name: 'MedianPrice',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Median Price - Average of high and low',
                preset: {
                    name: 'Median Price',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1,
                        color: '#9e9e9e'
                    }
                }
            }
        },
        use_for() { return ['MedianPrice'] },
        calc() {
            return {
                props: {},
                conf: { renderer: 'Spline' },
                update: `
                    return (high[0] + low[0]) / 2
                `
            }
        }
    }
}
</script>
